import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';

export const ListItemSkeleton = (): React.ReactNode => (
	<Box paddingBlock="space.150" paddingInline="space.200">
		<Inline space="space.150">
			<Box paddingBlock="space.025">
				<LoadingSkeleton width="32px" height="32px" />
			</Box>
			<Stack space="space.050">
				<LoadingSkeleton width="240px" height="20px" />
				<LoadingSkeleton width="112px" height="12px" />
			</Stack>
		</Inline>
	</Box>
);
